import { useMemo } from "react"
import { useQuery } from "urql"

import "../graphql/salesOpportunityQueries"

import { type Company, GetSalesOpportunityCustomerCompaniesDocument } from "@/graphql/codegen/graphql"
import { COMPANY_TYPE } from "@/screens/Companies/constants"

interface UseGetSalesOpportunityCompaniesByIdsParams {
  companyIds?: string[]
}

interface UseGetSalesOpportunityCompaniesByIdsReturn {
  companies: Pick<Company, "companyId" | "name">[]
  isFetching: boolean
}

export const useGetSalesOpportunityCompaniesByIds = ({
  companyIds,
}: UseGetSalesOpportunityCompaniesByIdsParams): UseGetSalesOpportunityCompaniesByIdsReturn => {
  const [{ data, fetching }] = useQuery({
    query: GetSalesOpportunityCustomerCompaniesDocument,
    variables: {
      input: {
        filter: { companyIds, types: [COMPANY_TYPE.CUSTOMER] },
        limit: companyIds?.length ?? 0,
        offset: 0,
      },
    },
    pause: !companyIds?.length,
  })

  const companies = useMemo(() => {
    if (data?.company?.list?.__typename === "CompanyListSuccess") {
      return data.company.list.companies
    }
    return []
  }, [data])

  return { companies, isFetching: fetching }
}
